<template>
	<div ref="phone-content" class="phone-content" id="phone-main"
		:style="{ 'background':'linear-gradient(to bottom, '+getBackground(data.page)+')' }">
		<!-- 顶部导航栏 -->
		<div v-if="data.page.params.model_type!='2'" class="phone-top optional" :style="getHeadBg(data.page)"
			@click="handelClickItem('page')">
			<div class="phone-top-jiao" :class="{ 
        selected: 'page' === selectedIndex,
        [data.page.style.titleTextColor]: true,
      }"></div>
			<p class="title" :style="{ color: data.page.style.titleTextColor }"
				v-if="data.page.params.model_type == '0'">
				{{ data.page.params.title }}
			</p>
			<div class="more_shop" v-else>
				<i v-if="data.page.params.storeShow==1" class="el-icon-location-outline" :style="{
            color: data.page.style.searchTitTextColor,
          }"></i>
				<span v-if="data.page.params.storeShow==1" :style="{
            color: data.page.style.searchTitTextColor,
          }">门店名称</span>
				<i v-if="data.page.params.storeShow==1" class="el-icon-arrow-right" :style="{
            color: data.page.style.searchTitTextColor,
          }"></i>
				<div v-if="data.page.params.searchShow==1" class="search_cls" :style="{
            background: data.page.style.searchBackgroudColor,
          }">
					<i class="el-icon-search" :style="{
              color: data.page.style.searchTextColor,
            }"></i>
					<span :style="{
              color: data.page.style.searchTextColor,
            }">{{data.page.params.searchTips}}</span>
				</div>
			</div>
		</div>
		<!-- 内容区域 -->
		<div class="phone-main">
			<draggable :list="data.items" class="content" @update="handelDragItem"
				v-bind="{ animation: 120, filter: '.undrag' }">
				<!-- 内容元素 -->
				<div class="devise-item optional" v-for="(item, index) in data.items" :key="index"
					@click="handelClickItem(index)" :class="{
            selected: index === selectedIndex,
            undrag: $util.inArray(item.type, undragList),
          }" :style="renderItemStyle(item)">
					<!-- 轮播图 -->
					<div v-if="item.type == 'banner'" class="diy-banner" :style="{
              padding: `${item.style.paddingY}px ${item.style.paddingX1}px  ${item.style.paddingY1}px  ${item.style.paddingX}px`,
				background: item.style.background,
            }">
						<img class="image" v-for="(dataItem, dataIdx) in item.data" :key="`${index}_${dataIdx}_img`"
							v-show="dataIdx <= 1" :src="dataItem.imgUrl" :style="{
                  borderRadius: `${item.style.borderRadius}px`,
              overflow: 'hidden'
              }" />
						<div class="dots" v-if="item.style.btnShape=='round'&&item.params.dot==1"
							:style="{bottom:'calc(10px + '+item.style.paddingY1+'px)'}" :class="item.style.btnShape">
							<div v-for="(dataItem, dataIdx) in item.data" :key="`${index}_${dataIdx}_dots`"
								:style="{ background: item.style.btnColor }" class="dots-item"></div>
						</div>
						<div v-if="item.style.btnShape=='num'&&item.params.dot==1" class="dots"
							style="justify-content: flex-end;margin-right: 10px;"
							:style="{bottom:'calc(10px + '+item.style.paddingY1+'px)'}" :class="item.style.btnShape">
							<div :style="{ color: item.style.btnColor }">1/{{item.data.length}}</div>
						</div>
					</div>

					<!-- 图片组 -->
					<div v-else-if="item.type == 'image'" class="diy-image" :style="{
             
              background: item.style.background,
            }">
						<div class="item-image" v-for="(dataItm, dataIdx) in item.data" :key="`${index}_${dataIdx}`"
							:style="{
                 padding: `${item.style.paddingTop}px ${item.style.paddingLeft}px `,
               
              }" style="overflow: hidden;">
							<img :style="{ borderRadius:`${item.style.borderRadius}px`,}" class="image"
								:src="dataItm.imgUrl" />
						</div>
					</div>

					<!-- 限时秒杀 -->
					<div v-else-if="item.type == 'seckill'" style="display: block;overflow: hidden;" :style="{
		  				background: item.style.zubackground
		  			}">
						<div class="diy-seckill" :style="[seckillStyle(item)]">
							<div class="diy-seckill-head">
								<img class="diy-seckill-title" :src="item.params.title" />
								<div class="diy-seckill-time">
									<div class="diy-seckill-days"
										:style="{background:item.style.timebackground,color:item.style.timetext}">1
									</div>
									<div class="diy-seckill-text" :style="{color:item.style.timebackground}">天</div>
									<div class="diy-seckill-days"
										:style="{background:item.style.timebackground,color:item.style.timetext}">12
									</div>
									<div class="diy-seckill-text" :style="{color:item.style.timebackground}">:</div>
									<div class="diy-seckill-days"
										:style="{background:item.style.timebackground,color:item.style.timetext}">12
									</div>
									<div class="diy-seckill-text" :style="{color:item.style.timebackground}">:</div>
									<div class="diy-seckill-days"
										:style="{background:item.style.timebackground,color:item.style.timetext}">12
									</div>
									<div class="diy-seckill-text" :style="{color:item.style.timebackground}">结束</div>
								</div>
								<div class="diy-seckill-more">
									<div class="diy-seckill-tips" :style="{color:item.style.text}">{{item.params.text}}
									</div>
									<i class="el-icon-arrow-right" :style="{color:item.style.text}"></i>
								</div>
							</div>
							<div class="diy-seckill-box">
								<div v-for="(ite,inde) in item.data" :key="inde" class="diy-seckill-item">
									<img class="diy-seckill-good" :src="ite.goods?.images[0]['file']['url']" />
									<div class="diy-seckill-bottom">
										<div class="diy-seckill-flex">
											<img class="diy-seckill-img"
												src="https://mp.mocols.com/common/weishop/xian_price.png" />
											<div class="diy-seckill-price">
												<div class="diy-seckill-type">￥</div>
												<div class="diy-seckill-num">{{ite.show_goods_price || 0}}</div>
											</div>
										</div>
									</div>
								</div>
								<div v-for="(ite,inde) in (4-item.data.length)" :key="inde" class="diy-seckill-item"
									style="opacity: 0;">
									<img class="diy-seckill-good"
										src="https://qiniuyun.mocols.com/upload/images/20250314/202503141420283562.png" />
									<div class="diy-seckill-bottom">
										<div class="diy-seckill-flex">
											<img class="diy-seckill-img"
												src="https://mp.mocols.com/common/weishop/xian_price.png" />
											<div class="diy-seckill-price">
												<div class="diy-seckill-type">￥</div>
												<div class="diy-seckill-num">99.99</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!-- 超值单品 -->
					<div v-else-if="item.type == 'super'" style="display: block;overflow: hidden;" :style="{
		  				background: item.style.zubackground
		  			}">
						<div class="diy-seckill" :style="[seckillStyle(item)]">
							<div class="diy-seckill-head">
								<img class="diy-seckill-title" :src="item.params.title" />
								<div class="diy-seckill-more">
									<div class="diy-seckill-tips" :style="{color:item.style.text}">{{item.params.text}}
									</div>
									<i class="el-icon-arrow-right" :style="{color:item.style.text}"></i>
								</div>
							</div>
							<div class="diy-seckill-box">
								<div v-for="(ite,inde) in item.data" :key="inde" class="diy-seckill-item">
									<img class="diy-seckill-good" :src="ite.goods?.images[0]['file']['url']" />
									<div class="diy-seckill-bottom">
										<div class="diy-seckill-flex">
											<img class="diy-seckill-img"
												src="https://mp.mocols.com/common/weishop/xian_price.png" />
											<div class="diy-seckill-price">
												<div class="diy-seckill-type">￥</div>
												<div class="diy-seckill-num">{{ite.show_goods_price || 0}}</div>
											</div>
										</div>
									</div>
								</div>
								<div v-for="(ite,inde) in (4-item.data.length)" :key="inde" class="diy-seckill-item"
									style="opacity: 0;">
									<img class="diy-seckill-good"
										src="https://qiniuyun.mocols.com/upload/images/20250314/202503141420283562.png" />
									<div class="diy-seckill-bottom">
										<div class="diy-seckill-flex">
											<img class="diy-seckill-img"
												src="https://mp.mocols.com/common/weishop/xian_price.png" />
											<div class="diy-seckill-price">
												<div class="diy-seckill-type">￥</div>
												<div class="diy-seckill-num">99.99</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!-- 付费券包 -->
					<div v-else-if="item.type == 'couponpack'" style="display: block;overflow: hidden;" :style="{
				background: item.style.zubackground
			}">
						<div :style="[seckillStyle(item)]" class="diy-couponpack">
							<div class="couponpack_head">
								<!-- <div class="couponpack_head_tag" :style="{
						background: item.style.timebg,
						color: item.style.timecolor,
					}">敬请期待</div> -->
								<!-- {{item.params.text}} -->
								<div class="couponpack_head_title" :style="{
						color: item.style.timecolor,
					}">{{item.params.text}}</div>
								<div class="couponpack_head_box">
									<div class="couponpack_head_text" :style="{
							color: item.style.timecolor,
						}">查看更多</div>
									<!-- <div class="couponpack_head_time":style="{
						background: item.style.timebg,
						color: item.style.timecolor,
						}">22</div>
						<div class="couponpack_head_text" :style="{
							color: item.style.timecolor,
						}">:</div>
						<div class="couponpack_head_time" :style="{
							background: item.style.timebg,
							color: item.style.timecolor,
						}">12</div>
						<div class="couponpack_head_text" :style="{
							color: item.style.timecolor,
						}">:</div>
						<div class="couponpack_head_time" :style="{
							background: item.style.timebg,
							color: item.style.timecolor,
						}">00</div>
						<div class="couponpack_head_text" :style="{
							color: item.style.timecolor,
						}">截止</div> -->
								</div>
							</div>
							<!-- 付费券包模板1 -->
							<div v-show="item.style.model=='model1'" class="couponpack_good" :style="{
						background: item.style.model1_bg,
						borderRadius: item.style.model1_borderRadius+'px',
						padding:item.style.model1_paddingTop+'px '+item.style.model1_paddingLeft+'px'
					}">
								<div v-for="(ite,inde) in item.data" :key="inde" class="couponpack_good_item" :style="{
              borderRadius: item.style.model1_borderRadius+'px',
              background:item.style.model1_goodbg,
            }">
									<img class="couponpack_good_img"
										:src="ite.image || 'https://qiniuyun.mocols.com/upload/images/20250314/202503141420283562.png'"
										alt="" />
									<div class="couponpack_good_flex">
										<div class="couponpack_good_title" :style="{
                color: item.style.model1_goodtcolor,
              }">{{ite.name}}</div>
										<div
											style="display: flex;align-items: flex-end;margin-top: 7px;margin-bottom: 7px;">
											<div class="couponpack_good_price">
												<div class="couponpack_good_fu" :style="{
                    color: item.style.model1_goodncolor,
                  }">￥</div>
												<div class="couponpack_good_num" :style="{
                    color: item.style.model1_goodncolor,
                  }">{{ite.price}}</div>
											</div>
											<div class="couponpack_good_old" :style="{
                    color: item.style.model1_goodocolor,
                  }">￥{{ite.line_price}}</div>
										</div>
										<div class="couponpack_good_but" :style="{
                    color: item.style.model1_goodbutcolor,
                    background:item.style.model1_goodbutbg
                  }">购买</div>
									</div>
								</div>
							</div>
							<!-- 付费券包模板2 -->
							<!-- padding:item.style.model1_paddingTop+'px '+item.style.model1_paddingLeft+'px' -->
							<!-- background: item.style.model1_bg, -->
							<div v-show="item.style.model=='model2'" class="couponpack_good couponpack_good_model2"
								:style="{
						borderRadius: item.style.model1_borderRadius+'px',
					}">
								<div v-for="(ite,inde) in item.data" :key="inde" class="couponpack_good_item" :style="{
              borderRadius: item.style.model1_borderRadius+'px',
              background:item.style.model1_goodbg,
            }">
									<img class="couponpack_good_img"
										:src="ite.image || 'https://qiniuyun.mocols.com/upload/images/20250314/202503141420283562.png'"
										alt="" />
									<div class="couponpack_good_flex">
										<div class="couponpack_good_title" :style="{
                color: item.style.model1_goodtcolor,
              }">{{ite.name}}</div>
										<div
											style="display: flex;align-items: flex-end;margin-top: 14px;margin-bottom: 7px;">
											<div class="couponpack_good_price">
												<div class="couponpack_good_fu" :style="{
                    color: item.style.model1_goodncolor,
                  }">￥</div>
												<div class="couponpack_good_num" :style="{
                    color: item.style.model1_goodncolor,
                  }">{{ite.price}}</div>
											</div>
											<div class="couponpack_good_old" :style="{
                    color: item.style.model1_goodocolor,
                  }">￥{{ite.line_price}}</div>
										</div>
									</div>
									<div class="lineBox" :style="{borderLeft:'1px dotted '+item.style.background}">
										<div class="dot1" :style="{color:item.style.background}">●</div>
										<div class="dot2" :style="{color:item.style.background}">●</div>
									</div>
									<div class="couponpack_good_but couponpack_good_but1" :style="{
              color: item.style.model1_goodbutcolor,
              background:item.style.model1_goodbutbg
            }">购买</div>
								</div>
							</div>
							<!-- 付费券包模板3 -->
							<div v-show="item.style.model=='model3'" class="couponpack_good couponpack_good_model3"
								:style="{
						background: item.style.model1_bg,
						borderRadius: item.style.model1_borderRadius+'px',
						padding:item.style.model1_paddingTop+'px '+item.style.model1_paddingLeft+'px'
					}">
								<div v-for="(ite,inde) in item.data" :key="inde" class="couponpack_good_item" :style="{
              borderRadius: item.style.model1_borderRadius+'px ',
              background:item.style.background,
            }">
									<div class="couponpack_good_flex1"
										:style="{ background:item.style.model1_goodbg,'--after-bg-color':item.style.model1_goodbg}">
										<img class="couponpack_good_img"
											:src="ite.image || 'https://qiniuyun.mocols.com/upload/images/20250314/202503141420283562.png'"
											alt="" />
										<div class="couponpack_good_flex">
											<div class="couponpack_good_title" :style="{
                  color: item.style.model1_goodtcolor,
                }">{{ite.name}}</div>
											<div
												style="display: flex;align-items: flex-end;margin-top: 7px;margin-bottom: 7px;">
												<div class="couponpack_good_price">
													<div class="couponpack_good_fu" :style="{
                      color: item.style.model1_goodncolor,
                    }">￥</div>
													<div class="couponpack_good_num" :style="{
                      color: item.style.model1_goodncolor,
                    }">{{ite.price}}</div>
												</div>
												<div class="couponpack_good_old" :style="{
                      color: item.style.model1_goodocolor,
                    }">￥{{ite.line_price}}</div>
											</div>
										</div>
									</div>
									<div class="couponpack_good_but couponpack_good_but2" :style="{
                color: item.style.model1_goodbutcolor,
                background:item.style.model1_goodbutbg
              }">购买</div>
								</div>
							</div>
						</div>

					</div>
					<!-- 小程序直播 -->
					<div v-else-if="item.type == 'live'" class="diy-live" style="overflow: hidden;" :style="{
		  				background: item.style.zubackground
		  			}">
						<block v-for="(ite,ind) in item.data">
							<div v-if="item.params.type==1" class="diy-live-box1" :style="{
						  marginTop: item.style.paddingTop + 'px',
						  marginBottom: item.style.paddingBottom + 'px',
						  marginLeft: item.style.paddingLeft + 'px',
						  marginRight: item.style.paddingRight + 'px',
						  borderRadius:item.style.borderRadius + 'px'
					  }">
								<img class="diy-live-bg" :src="ite.cover_img" alt="" srcset="" />
								<div class="diy-live-status">
									<div class="diy-live-online">
										<!-- <img class="diy-live-icon" src="https://qiniuyun.mocols.com/upload/images/20250314/202503141420283562.png" alt="" srcset="" /> -->
										<div class="diy-live-text">直播中</div>
									</div>
									<div class="diy-live-time">12月31日 12:00</div>
								</div>
								<div class="diy-live-data">
									<div class="diy-live-title">{{ite.name || ''}}</div>
									<div class="diy-live-user">
										<!-- <img class="diy-live-phone" src="https://qiniuyun.mocols.com/upload/images/20250314/202503141420283562.png" alt="" srcset="" /> -->
										<span>主播：{{ite.anchor_name || ''}}</span>
										<span style="padding: 0 4px;">|</span>
										<span>商品：0</span>
									</div>
								</div>
							</div>

							<div v-else class="diy-live-box2" :style="{
						  marginTop: item.style.paddingTop + 'px',
						  marginBottom: item.style.paddingTop + 'px',
						  marginLeft: item.style.paddingLeft + 'px',
						  marginRight: item.style.paddingLeft + 'px',
						  borderRadius:item.style.borderRadius + 'px'
					  }">
								<div class="diy-live-status">
									<div class="diy-live-online">
										<!-- <img class="diy-live-icon" src="https://qiniuyun.mocols.com/upload/images/20250314/202503141420283562.png" alt="" srcset="" /> -->
										<div class="diy-live-text">直播中</div>
									</div>
									<div class="diy-live-time">12月31日 12:00</div>
								</div>
								<img class="diy-live-left" :src="ite.feeds_img" alt="" srcset="" />
								<div class="diy-live-right">
									<div class="diy-live-top">
										<div class="diy-live-title1">{{ite.name || ''}}</div>
										<div class="diy-live-data1">
											<!-- <img class="diy-live-dataimg" src="https://qiniuyun.mocols.com/upload/images/20250314/202503141420283562.png" alt="" srcset="" /> -->
											<span class="diy-live-data1zhu">主播: {{ite.anchor_name || ''}}</span>
										</div>
									</div>
									<div class="diy-live-good">
										<div class="diy-live-gooditem">
											<img class="diy-live-goodimg"
												src="https://qiniuyun.mocols.com/upload/images/20250314/202503141420283562.png"
												alt="" />
											<div class="diy-live-price">￥99</div>
										</div>
										<div class="diy-live-gooditem">
											<img class="diy-live-goodimg"
												src="https://qiniuyun.mocols.com/upload/images/20250314/202503141420283562.png"
												alt="" />
											<div class="diy-live-num">+0</div>
										</div>
									</div>
								</div>
							</div>
						</block>
					</div>
					<!-- 图片橱窗 -->
					<div v-else-if="item.type == 'window'" class="diy-window" :style="{
              background: item.style.background,
              padding: `${item.style.paddingTop}px ${item.style.paddingLeft}px`,
            }">
						<ul v-if="item.style.layout > -1" class="data-list clearfix"
							:class="`avg-sm-${item.style.layout}`">
							<li v-for="(window, dataIdx) in item.data" :key="`${index}_${dataIdx}`" class="data-item"
								:style="{
                  padding: `${item.style.paddingTop}px ${item.style.paddingLeft}px`,
                }">
								<div class="item-image">
									<img class="image" :src="window.imgUrl" />
								</div>
							</li>
						</ul>
						<div class="display" v-else>
							<div class="display-left" :style="{
                  padding: `${item.style.paddingTop}px ${item.style.paddingLeft}px`,
                }">
								<img class="image" :src="item.data[0].imgUrl" />
							</div>
							<div class="display-right">
								<div v-if="item.data.length >= 2" class="display-right1" :style="{
                    padding: `${item.style.paddingTop}px ${item.style.paddingLeft}px`,
                  }">
									<img class="image" :src="item.data[1].imgUrl" />
								</div>
								<div class="display-right2">
									<div v-if="item.data.length >= 3" class="left" :style="{
                      padding: `${item.style.paddingTop}px ${item.style.paddingLeft}px`,
                    }">
										<img class="image" :src="item.data[2].imgUrl" />
									</div>
									<div v-if="item.data.length >= 4" class="right" :style="{
                      padding: `${item.style.paddingTop}px ${item.style.paddingLeft}px`,
                    }">
										<img class="image" :src="item.data[3].imgUrl" />
									</div>
								</div>
							</div>
						</div>
					</div>

					<!-- 热区组 -->
					<div v-else-if="item.type == 'hotZone'" class="diy-hotZone" :style="{
				padding: `${item.style.paddingTop}px ${item.style.paddingRight}px ${item.style.paddingBottom}px ${item.style.paddingLeft}px`,
              // paddingTop: item.style.paddingTop + 'px',
              // paddingBottom: item.style.paddingBottom + 'px',
              background: item.style.background
            }">
						<div class="item-image" style="overflow: hidden;" :style="{
                borderRadius:`${item.style.radiusTop}px ${item.style.radiusTop}px ${item.style.radiusBottom}px ${item.style.radiusBottom}px`
              }">
							<img class="image" :src="item.data.imgUrl" />
						</div>
					</div>

					<!-- 视频组 -->
					<div v-else-if="item.type == 'video'" class="diy-video"
						:style="{background:item.style.zubackground, padding: `${item.style.paddingTop}px ${item.style.paddingLeft}px` }">
						<video :style="{ height: `${item.style.height}px`,borderRadius:`${item.style.borderRadius}px` }"
							:src="item.params.videoUrl" :poster="item.params.poster" controls>
							您的浏览器不支持 video 标签
						</video>
					</div>

					<!-- 文章组 -->
					<div v-else-if="item.type == 'article'" class="diy-article" :style="{
				  padding: `${item.style.paddingY}px ${item.style.paddingX1}px  ${item.style.paddingY1}px  ${item.style.paddingX}px`,
					background: item.style.zubackground
				}">
							<div :style="{borderRadius:`${item.style.radius}px`}" class="article-item" v-for="(dataItm, dataIdx) in item.params.source == 'choice'
					? item.data
					: item.defaultData" :key="`${index}_${dataIdx}`" :class="`show-type__${dataItm.show_type}`">
								<!-- 小图模式 -->
								<template v-if="dataItm.show_type == 10">
									<div class="article-item__left flex-box">
										<div class="article-item__title twoline-hide">
											<span class="article-title">{{ dataItm.title }}</span>
										</div>
										<div class="article-item__footer">
											<span class="article-views">{{ dataItm.views_num }}次浏览</span>
										</div>
									</div>
									<div class="article-item__image">
										<img class="image" :src="dataItm.image" alt />
									</div>
								</template>
								<!-- 大图模式 -->
								<template v-if="dataItm.show_type == 20">
									<div class="article-item__title">
										<span class="article-title">{{ dataItm.title }}</span>
									</div>
									<div class="article-item__image">
										<img class="image" :src="dataItm.image" />
									</div>
									<div class="article-item__footer">
										<span class="article-views">{{ dataItm.views_num }}次浏览</span>
									</div>
								</template>
							</div>
						</div>

					<!-- 搜索栏 -->
					<div v-else-if="item.type == 'search'" class="diy-search1"
						:style="{ background: item.style.zubackground,borderRadius:item.style.radiusTop+'px '+item.style.radiusTop+'px '+item.style.radiusBottom+'px '+item.style.radiusBottom+'px '}">
						<div :class="{ sticky: item.params.sticky }"
							:style="{ padding: item.style.paddingTop +'px '+item.style.paddingRight +'px '+item.style.paddingBottom +'px '+item.style.paddingLeft+'px' }">
							<!--  -->
							<div class="inner" :style="{border:'1px solid '+item.style.borderColor}"
								:class="item.style.searchStyle">
								<!-- height:item.style.height+'px',lineHeight:item.style.height+'px' -->
								<div class="search-input"
									:style="{ textAlign: item.style.textAlign , background: item.style.background,}">
									<i class="el-icon-search search-icon" :style="{ color: item.style.color }"></i>
									<!-- <a-icon class="search-icon" :component="PageIcon.search" /> -->
									<span :style="{ color: item.style.color }">{{ item.params.placeholder }}</span>
								</div>
							</div>
						</div>
					</div>
					<!-- 门店切换 -->
					<div v-else-if="item.type == 'stores'">
						<div
							:style="{ padding: item.style.paddingTop +'px '+item.style.paddingRight +'px '+item.style.paddingBottom +'px '+item.style.paddingLeft +'px',background: item.style.background}">
							<div class="stores_block"></div>
						</div>
						<div class="diy-stores"
							:style="{ padding: item.style.paddingTop +'px '+item.style.paddingRight +'px '+item.style.paddingBottom +'px '+item.style.paddingLeft +'px',background: item.style.background}">
							<img v-if="item.params.style==1" class="stores_img" src="@/static/img/icon_store.png" />
							<div class="stores_flex">
								<div v-if="item.params.style==1" class="stores_flex_title"
									:style="{color:item.style.titlecolor}">门店名称</div>
								<div class="stores_flex_data">
									<i class="el-icon-location-outline" :style="{color:item.style.addresscolor}"
										style="font-size: 14px;"></i>
									<!-- <img class="stores_flex_img" src="@/static/img/icon_address.png" alt="" /> -->
									<div class="stores_flex_text"
										:style="{flex:item.params.style==1?'1 !important':' ',color:item.style.addresscolor}">
										青羊区中开大厦</div>
									<div v-if="item.params.style==2" class="stores_flex_title1"
										style="margin-left: 5px;" :style="{color:item.style.titlecolor}">门店名称</div>
									<i class="el-icon-arrow-right" v-if="item.params.style==2"
										style="font-weight: bold;" :style="{color:item.style.addresscolor }"></i>
								</div>
							</div>
							<div class="stores_but" v-if="item.params.style==1"
								:style="{color:item.style.addresscolor,border:'1px solid '+item.style.addresscolor}">
								切换门店</div>
						</div>
					</div>

					<!-- 店铺公告 -->
					<div v-else-if="item.type == 'notice'" class="diy-notice"
						:style="{ background: item.style.zubackground,padding: `${item.style.paddingTop}px ${item.style.paddingLeft}px` }">
						<div class="notice-body" :style="{
                background: item.style.background,
                color: item.style.textColor,
				borderRadius:`${item.style.radiusTop}px `
              }">
							<div class="notice__icon">
								<!-- <a-icon class="notice-icon" :component="PageIcon.volumeFill" /> -->
							</div>
							<div class="notice__text flex-box oneline-hide">
								<span>{{ item.params.text }}</span>
							</div>
						</div>
					</div>

					<!-- 导航组 -->
					<div class="" v-else-if="item.type == 'navBar'" :style="{
              background: item.style.zubackground,
			  padding: `${item.style.paddingY}px ${item.style.paddingX1}px  ${item.style.paddingY1}px  ${item.style.paddingX}px`,
            }">
						<div class="diy-navBar" :style="{ 
				  background: item.style.background,
				  color: item.style.textColor,
				  borderRadius: ` ${item.style.borderRadius}px ${item.style.borderRadius}px ${item.style.borderRadius1}px ${item.style.borderRadius1}px`,
				  overflow: 'hidden',
				  maxHeight:item.params?(item.params.interactive==2?'none':(item.params.rowNum*90+'px')):'none'
				}">
							<ul class="data-list clearfix" :class="`avg-sm-${item.style.rowsNum}`">
								<li class="item-nav" v-for="(dataItm, dataIdx) in item.data"
									:key="`${index}_${dataIdx}`">
									<div class="item-image">
										<img class="image" :style="{
							  borderRadius: item.style?.navRadius==2?'4px':(item.style?.navRadius==3?'50%':0),
							}" :src="dataItm.imgUrl" />
									</div>
									<p class="item-text oneline-hide">{{ dataItm.text }}</p>
								</li>
							</ul>
						</div>
					</div>

					<!-- 门店分类 -->
					<div class="" v-else-if="item.type == 'life'" :style="{
			    background: item.style.zubackground,
						  padding: `${item.style.paddingY}px ${item.style.paddingX1}px  ${item.style.paddingY1}px  ${item.style.paddingX}px`,
			  }">
						<div class="diy-navBar" :style="{ 
				  background: item.style.background,
				  color: item.style.textColor,
				  borderRadius: ` ${item.style.borderRadius}px ${item.style.borderRadius}px ${item.style.borderRadius1}px ${item.style.borderRadius1}px`,
				  overflow: 'hidden'
				}">
							<ul class="data-list clearfix" :class="`avg-sm-${item.style.rowsNum}`">
								<li class="item-nav" v-for="(dataItm, dataIdx) in item.data"
									:key="`${index}_${dataIdx}`">
									<div class="item-image">
										<img class="image" :style="{
							  borderRadius: item.style?.navRadius==2?'4px':(item.style?.navRadius==3?'50%':0),
							}" :src="dataItm.imgUrl" />
									</div>
									<p class="item-text oneline-hide">{{ dataItm.text }}</p>
								</li>
							</ul>
						</div>
					</div>
					<!-- 门店列表 -->
					<div class="" v-else-if="item.type == 'lifelist'" :style="{
			    background: item.style.zubackground,
						  padding: `${item.style.paddingY}px ${item.style.paddingX1}px  ${item.style.paddingY1}px  ${item.style.paddingX}px`,
			  }">
						<lifelistBox :params="item.params"></lifelistBox>
					</div>
					<!-- 积分商品组 -->
					<div v-else-if="item.type == 'pointergoods'" class="diy-goods" :style="{
			    background: item.style.background,
			    padding: `${item.style.paddingY}px ${item.style.paddingX1}px  ${item.style.paddingY1}px  ${item.style.paddingX}px`,
			  }" :class="[ `column${item.style.column}`
						]">
						<div class="goods-list" :class="[
			      `display-${item.style.display}`,
			      `column-${item.style.column}`
			    ]">
							<el-carousel class="wh100" v-if="item.style.column == 2 && item.style.swipter==1" :style="{
			        marginBottom: `${item.style.itemMargin}px`,
			        borderRadius: `${item.style.borderRadius}px`,
							  height:(item.style.column==3?'110px':'260px')
			      }" :height="item.style.column==3?'110px':'260px'" arrow="nerver" indicator-position="none">
								<el-carousel-item class="wh100" :style="{height:(item.style.column==3?'110px':'260px')}"
									v-for="(ite,ind) in item.swipter" :key="(ind)">
									<img class="wh100" :src="ite.imgUrl"
										:style="{height:item.style.column==3?'110px':'260px'}" alt="" />
								</el-carousel-item>
							</el-carousel>
							<div class="goods-item" v-for="(dataItm, dataIdx) in item.params.source == 'choice'
			        ? item.data
			        : item.defaultData" :key="`${index}_${dataIdx}`" :class="[`display-${item.style.cardType}`]" :style="{
			        marginBottom: `${item.style.itemMargin}px`,
			        borderRadius: `${item.style.borderRadius}px`,
			      }">
								<!-- 单列商品 -->
								<template v-if="item.style.column == 1">
									<div class="flex">
										<!-- 商品图片 -->
										<div class="goods-item-left">
											<img v-if='item.style.hotTag==1' class="image_tag"
												:src="item.style.hotImg" />
											<img class="image" :src="dataItm.banner[0].image" />
										</div>
										<div class="goods-item-right">
											<div class="goods-info">
												<div v-if="$util.inArray('goodsName', item.style.show)"
													class="goods-name" :class="[
			                  item.style.goodsNameRows == 'two'
			                    ? 'twoline-hide'
			                    : 'oneline-hide',
			                  `row-${item.style.goodsNameRows}`,
			                ]" :style="{fontWeight:item.style.goodsWeight,fontSize:(item.style.goodsSize?item.style.goodsSize:14)+'px'}">
													{{ dataItm.name }}
												</div>
												<div v-if="$util.inArray('goodsTag', item.style.show)"
													class="goods-tag">
													<span class="goods-tag-style1 goods-tag-item"
														:style="{ 'color': item.style.sellingColor }">3.5折</span>
												</div>
												<div style="display:flex">
													<div v-if=" $util.inArray('goodsGrade', item.style.show)"
														:style="{background:item.style.sellingColor+'1A'}"
														class="zu_a   " style="margin-right: 10px;">
														<div class="zu_a1"
															:style="{ '--after-bg-color':item.style.sellingColor,'background': item.style.sellingColor }">
															现金</div>
														<div class="flex_c ml10">
															<div class="zu_a_price">
																<div class="zu_a_type"
																	:style="{ 'color': item.style.sellingColor }">￥
																</div>
																<div class="zu_a_num"
																	:style="{ 'color': item.style.sellingColor }">
																	{{dataItm.price}}</div>
															</div>
														</div>
													</div>
													<div v-if="$util.inArray('goodsSales', item.style.show)"
														class="goods-sales oneline-hide">
														<span class="sales">已兑{{ dataItm.sale_count ||0 }}</span>
													</div>
												</div>
												<div class="footer">
													<div v-if="$util.inArray('goodsPrice', item.style.show)"
														class="goods-price oneline-hide"
														:style="{ color: item.style.priceColor }">
														<span class="unit">积分</span>
														<span class="value">{{ dataItm.points }}</span>
													</div>
													<div v-show="
			                    $util.inArray('cartBtn', item.style.show) &&
			                    item.style.column < 3
			                  " class="action">
														<div class="btn-cart"
															:style="{ color: item.style.btnCartColor }"
															style="width: auto;">
															<span
																v-if="item.style.btnCartStyle==1||item.style.btnCartStyle==3"
																class="cart-icon iconfont"
																:class="[`icon-jiagou${item.style.btnCartStyle}`]"></span>
															<span v-if="item.style.btnCartStyle==2"
																:style="{background:item.style.btnCartColor}"
																style="width: 18px;height: 18px;line-height: 18px; border-radius: 50%;text-align: center;color: #fff;display: inline-block;">
																<i class="cart-icon iconfont icon-jiagou3"
																	style="font-size: 12px;"></i>
															</span>
															<span class="cart-an" v-if="item.style.btnCartStyle==4"
																:style="{background:item.style.btnCartColor}" style="">
																兑换
															</span>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</template>
								<!-- 两列/三列 -->
								<template v-else>
									<div class="goods-image">
										<img v-if='item.style.hotTag==1' class="image_tag" :src="item.style.hotImg" />
										<img class="image" :src="dataItm.banner[0].image" />
									</div>
									<div class="goods-info">
										<div v-if="$util.inArray('goodsName', item.style.show)" class="goods-name"
											:class="[
			              item.style.goodsNameRows == 'two'
			                ? 'twoline-hide'
			                : 'oneline-hide',
			              `row-${item.style.goodsNameRows}`,
			            ]" :style="{fontWeight:item.style.goodsWeight,fontSize:(item.style.goodsSize?item.style.goodsSize:14)+'px'}">
											{{ dataItm.name }}
										</div>
										<div v-if="$util.inArray('goodsTag', item.style.show)" class="goods-tag">
											<span class="goods-tag-style1 goods-tag-item"
												:style="{ 'color': item.style.sellingColor }">{{((dataItm.goods_price_min/dataItm.line_price_min).toFixed(1))*10}}折</span>
										</div>
										<div style="display:flex">
											<div v-if="$util.inArray('goodsGrade', item.style.show)"
												:style="{background:item.style.sellingColor+'1A'}" class="zu_a   "
												style="margin-right: 10px;">
												<div class="zu_a1"
													:style="{ '--after-bg-color':item.style.sellingColor,'background': item.style.sellingColor }">
													现金</div>
												<div class="flex_c ml10">
													<div class="zu_a_price">
														<div class="zu_a_type"
															:style="{ 'color': item.style.sellingColor }">￥</div>
														<div class="zu_a_num"
															:style="{ 'color': item.style.sellingColor }">
															{{dataItm.price}}</div>
													</div>
												</div>
											</div>
											<div v-if="$util.inArray('goodsSales', item.style.show)"
												class="goods-sales oneline-hide">
												<span class="sales">已兑{{ dataItm.sale_count ||0 }}</span>
											</div>
										</div>
										<div class="footer">
											<div v-if="$util.inArray('goodsPrice', item.style.show)"
												class="goods-price oneline-hide"
												:style="{ color: item.style.priceColor }">
												<span class="unit">积分</span>
												<span class="value">{{ dataItm.points }}</span>
											</div>
											<div v-show="
			                $util.inArray('cartBtn', item.style.show) &&
			                item.style.column < 3
			              " class="action">
												<div class="btn-cart" :style="{ color: item.style.btnCartColor }"
													style="width: auto;">
													<!-- <span class="cart-icon iconfont" :class="[`icon-jiagou${item.style.btnCartStyle}`]"></span> -->
													<span v-if="item.style.btnCartStyle==1||item.style.btnCartStyle==3"
														class="cart-icon iconfont"
														:class="[`icon-jiagou${item.style.btnCartStyle}`]"></span>
													<span v-if="item.style.btnCartStyle==2"
														:style="{background:item.style.btnCartColor}"
														style="width: 18px;height: 18px;line-height: 18px; border-radius: 50%;text-align: center;color: #fff;display: inline-block;">
														<i class="cart-icon iconfont icon-jiagou3"
															style="font-size: 12px;"></i>
													</span>
													<span class="cart-an" v-if="item.style.btnCartStyle==4"
														:style="{background:item.style.btnCartColor}" style="">
														兑换
													</span>
												</div>
											</div>
										</div>
										<div v-if="$util.inArray('goodsTop', item.style.show)" class="good-top">
											店铺人气榜商品前TOP10</div>
									</div>
								</template>
							</div>
						</div>
					</div>
					<!-- 商品组 -->
					<div v-else-if="item.type == 'goods'" class="diy-goods" :style="{
              background: item.style.background,
              padding: `${item.style.paddingY}px ${item.style.paddingX1}px  ${item.style.paddingY1}px  ${item.style.paddingX}px`,
            }" :class="[ `column${item.style.column}`
			]">
						<div class="goods-list" :class="[
                `display-${item.style.display}`,
                `column-${item.style.column}`
              ]">
							<el-carousel class="wh100" v-if="item.style.column == 2 && item.style.swipter==1" :style="{
                  marginBottom: `${item.style.itemMargin}px`,
                  borderRadius: `${item.style.borderRadius}px`,
				  height:(item.style.column==3?'110px':'260px')
                }" :height="item.style.column==3?'110px':'260px'" arrow="nerver" indicator-position="none">
								<el-carousel-item class="wh100" :style="{height:(item.style.column==3?'110px':'260px')}"
									v-for="(ite,ind) in item.swipter" :key="(ind)">
									<img class="wh100" :src="ite.imgUrl"
										:style="{height:item.style.column==3?'110px':'260px'}" alt="" />
								</el-carousel-item>
							</el-carousel>
							<div class="goods-item" v-for="(dataItm, dataIdx) in item.params.source == 'choice'
                  ? item.data
                  : item.defaultData" :key="`${index}_${dataIdx}`" :class="[`display-${item.style.cardType}`]" :style="{
                  marginBottom: `${item.style.itemMargin}px`,
                  borderRadius: `${item.style.borderRadius}px`,
                }">
								<!-- 单列商品 -->
								<template v-if="item.style.column == 1">
									<div class="flex">
										<!-- 商品图片 -->

										<div class="goods-item-left">
											<img v-if='item.style.hotTag==1' class="image_tag"
												:src="item.style.hotImg" />
											<img class="image" :src="dataItm.goods_image" />
										</div>
										<div class="goods-item-right">
											<div class="goods-info">
												<div v-if="$util.inArray('goodsName', item.style.show)"
													class="goods-name" :class="[
                            item.style.goodsNameRows == 'two'
                              ? 'twoline-hide'
                              : 'oneline-hide',
                            `row-${item.style.goodsNameRows}`,
                          ]" :style="{fontWeight:item.style.goodsWeight,fontSize:(item.style.goodsSize?item.style.goodsSize:14)+'px'}">
													{{ dataItm.goods_name }}
												</div>
												<!-- <div
                          v-if="$util.inArray('sellingPoint', item.style.show)"
                          class="goods-selling"
                        >
                          <span
                            class="selling oneline-hide"
                            :style="{ color: item.style.sellingColor }"
                            >{{ dataItm.selling_point }}</span
                          >
                        </div> -->
												<div v-if="$util.inArray('goodsTag', item.style.show)"
													class="goods-tag">
													<span class="goods-tag-style1 goods-tag-item"
														:style="{ 'color': item.style.sellingColor }">3.5折</span>
													<!-- <span class="goods-tag-style2 goods-tag-item" :style="{ 'color': item.style.sellingColor,'border': '1px solid '+ item.style.sellingColor }">品牌</span> -->
													<!-- <view class="goods-tag-style2 goods-tag-item">{{ite.name || ''}}</view> -->
													<!-- <span class="goods-tag-style2 goods-tag-item" :style="{ 'color': item.style.sellingColor,'border': '1px solid '+ item.style.sellingColor }">同城配送</span> -->
													<!-- <span class="goods-tag-style2 goods-tag-item" :style="{ 'color': item.style.sellingColor,'border': '1px solid '+ item.style.sellingColor }">活动</span> -->
												</div>
												<div style="display:flex">
													<div v-if=" $util.inArray('goodsGrade', item.style.show)"
														:style="{background:item.style.sellingColor+'1A'}"
														class="zu_a   " style="margin-right: 10px;">
														<div class="zu_a1"
															:style="{ '--after-bg-color':item.style.sellingColor,'background': item.style.sellingColor }">
															尊享价</div>
														<div class="flex_c ml10">
															<div class="zu_a_price">
																<div class="zu_a_type"
																	:style="{ 'color': item.style.sellingColor }">￥
																</div>
																<div class="zu_a_num"
																	:style="{ 'color': item.style.sellingColor }">
																	{{dataItm.goods_price_min}}</div>
															</div>
														</div>
													</div>
													<div v-if="$util.inArray('goodsSales', item.style.show)"
														class="goods-sales oneline-hide">
														<span class="sales">已售{{ dataItm.goods_sales }}</span>
													</div>
												</div>
												<div class="footer">
													<div v-if="$util.inArray('goodsPrice', item.style.show)"
														class="goods-price oneline-hide"
														:style="{ color: item.style.priceColor }">
														<span class="unit">￥</span>
														<span class="value">{{
                              dataItm.goods_price_min
                            }}</span>
														<!-- <span class="unit2">到手价</span> -->
														<span v-if="$util.inArray('linePrice', item.style.show)"
															class="line-price">
															<span class="unit">￥</span>
															<span class="value">{{
                                dataItm.line_price_min
                              }}</span>
														</span>
													</div>
													<div v-show="
                              $util.inArray('cartBtn', item.style.show) &&
                              item.style.column < 3
                            " class="action">
														<div class="btn-cart"
															:style="{ color: item.style.btnCartColor }"
															style="width: auto;">
															<span
																v-if="item.style.btnCartStyle==1||item.style.btnCartStyle==3"
																class="cart-icon iconfont"
																:class="[`icon-jiagou${item.style.btnCartStyle}`]"></span>
															<span v-if="item.style.btnCartStyle==2"
																:style="{background:item.style.btnCartColor}"
																style="width: 18px;height: 18px;line-height: 18px; border-radius: 50%;text-align: center;color: #fff;display: inline-block;">
																<i class="cart-icon iconfont icon-jiagou3"
																	style="font-size: 12px;"></i>
															</span>
															<span class="cart-an" v-if="item.style.btnCartStyle==4"
																:style="{background:item.style.btnCartColor}" style="">
																购买
															</span>
															<!-- <a-icon
                                class="cart-icon"
                                :component="PageIcon[`jiagou${item.style.btnCartStyle}`]"
                              /> -->
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</template>
								<!-- 两列/三列 -->
								<template v-else>
									<div class="goods-image">
										<img v-if='item.style.hotTag==1' class="image_tag" :src="item.style.hotImg" />
										<img class="image" :src="dataItm.goods_image" />
									</div>
									<div class="goods-info">
										<div v-if="$util.inArray('goodsName', item.style.show)" class="goods-name"
											:class="[
                        item.style.goodsNameRows == 'two'
                          ? 'twoline-hide'
                          : 'oneline-hide',
                        `row-${item.style.goodsNameRows}`,
                      ]" :style="{fontWeight:item.style.goodsWeight,fontSize:(item.style.goodsSize?item.style.goodsSize:14)+'px'}">
											{{ dataItm.goods_name }}
										</div>
										<!-- <div
                      v-if="$util.inArray('sellingPoint', item.style.show)"
                      class="goods-selling"
                    >
                      <span
                        class="selling oneline-hide"
                        :style="{ color: item.style.sellingColor }"
                        >{{ dataItm.selling_point }}</span
                      >
                    </div> -->
										<div v-if="$util.inArray('goodsTag', item.style.show)" class="goods-tag">
											<span class="goods-tag-style1 goods-tag-item"
												:style="{ 'color': item.style.sellingColor }">{{((dataItm.goods_price_min/dataItm.line_price_min).toFixed(1))*10}}折</span>
											<!-- <span class="goods-tag-style2 goods-tag-item" :style="{ 'color': item.style.sellingColor,'border': '1px solid '+ item.style.sellingColor }">同城配送</span> -->
											<!-- <span class="goods-tag-style2 goods-tag-item" :style="{ 'color': item.style.sellingColor,'border': '1px solid '+ item.style.sellingColor }">品牌</span> -->
											<!-- <view class="goods-tag-style2 goods-tag-item">{{ite.name || ''}}</view> -->
											<!-- <span class="goods-tag-style2 goods-tag-item" :style="{ 'color': item.style.sellingColor,'border': '1px solid '+ item.style.sellingColor }">活动</span> -->
										</div>
										<div style="display:flex">
											<!-- v-if="dataItm.is_user_grade" -->
											<div v-if="$util.inArray('goodsGrade', item.style.show)"
												:style="{background:item.style.sellingColor+'1A'}" class="zu_a   "
												style="margin-right: 10px;">
												<div class="zu_a1"
													:style="{ '--after-bg-color':item.style.sellingColor,'background': item.style.sellingColor }">
													尊享价</div>
												<div class="flex_c ml10">
													<div class="zu_a_price">
														<div class="zu_a_type"
															:style="{ 'color': item.style.sellingColor }">￥</div>
														<div class="zu_a_num"
															:style="{ 'color': item.style.sellingColor }">
															{{dataItm.goods_price_min}}</div>
													</div>
												</div>
											</div>
											<div v-if="$util.inArray('goodsSales', item.style.show)"
												class="goods-sales oneline-hide">
												<span class="sales">已售{{ dataItm.goods_sales }}</span>
											</div>
										</div>
										<!-- <div
                      v-if="$util.inArray('goodsSales', item.style.show)"
                      class="goods-sales oneline-hide"
                    >
                      <span class="sales">已售{{ dataItm.goods_sales }}</span>
                    </div> -->
										<div class="footer">
											<div v-if="$util.inArray('goodsPrice', item.style.show)"
												class="goods-price oneline-hide"
												:style="{ color: item.style.priceColor }">
												<span class="unit">￥</span>
												<span class="value">{{ dataItm.goods_price_min }}</span>
												<!-- <span class="unit2">到手价</span> -->
												<span v-if="$util.inArray('linePrice', item.style.show)"
													class="line-price">
													<span class="unit">￥</span>
													<span class="value">{{
                            dataItm.line_price_min
                          }}</span>
												</span>
											</div>
											<div v-show="
                          $util.inArray('cartBtn', item.style.show) &&
                          item.style.column < 3
                        " class="action">
												<div class="btn-cart" :style="{ color: item.style.btnCartColor }"
													style="width: auto;">
													<!-- <span class="cart-icon iconfont" :class="[`icon-jiagou${item.style.btnCartStyle}`]"></span> -->
													<span v-if="item.style.btnCartStyle==1||item.style.btnCartStyle==3"
														class="cart-icon iconfont"
														:class="[`icon-jiagou${item.style.btnCartStyle}`]"></span>
													<span v-if="item.style.btnCartStyle==2"
														:style="{background:item.style.btnCartColor}"
														style="width: 18px;height: 18px;line-height: 18px; border-radius: 50%;text-align: center;color: #fff;display: inline-block;">
														<i class="cart-icon iconfont icon-jiagou3"
															style="font-size: 12px;"></i>
													</span>
													<span class="cart-an" v-if="item.style.btnCartStyle==4"
														:style="{background:item.style.btnCartColor}" style="">
														购买
													</span>
													<!-- <a-icon
                            class="cart-icon"
                            :component="PageIcon[`jiagou${item.style.btnCartStyle}`]"
                          /> -->
												</div>
											</div>
										</div>
										<div v-if="$util.inArray('goodsTop', item.style.show)" class="good-top">
											店铺人气榜商品前TOP10</div>
									</div>
								</template>
							</div>
						</div>
					</div>
					<!-- tab商品组 -->
					<div v-else-if="item.type == 'tabgoods'" :style="{
						background: item.style.background,
						padding: `${item.style.paddingY}px ${item.style.paddingX1}px  ${item.style.paddingY1}px  ${item.style.paddingX}px`,
					  }">
						<div class="good-tab">
							<div v-for="(ite,index) in item.params.tab" :key="index" class="good-tab-item">
								<div :style="{color:item.params.tabVals==ite.index?item.style.tabColor:'#000'}" class="good-tab-title">{{ite.title || ''}}</div>
								<div :style="{background:item.params.tabVals==ite.index?item.style.tabColor:'#fff',color:item.params.tabVals==ite.index?'#fff':'#000'}"
									class="good-tab-sub">{{ite.sub || ''}}</div>
							</div>
						</div>

						<div class="diy-goods" :class="[ `column${item.style.column}` ]">
							<div class="goods-list" :class="[
							  `display-${item.style.display}`,
							  `column-${item.style.column}`
							]">
								<!-- <el-carousel class="wh100" v-if="item.style.column == 2 && item.style.swipter==1" :style="{
			        marginBottom: `${item.style.itemMargin}px`,
			        borderRadius: `${item.style.borderRadius}px`,
							  height:(item.style.column==3?'110px':'260px')
			      }" :height="item.style.column==3?'110px':'260px'" arrow="nerver" indicator-position="none"  >
						      <el-carousel-item  class="wh100" :style="{height:(item.style.column==3?'110px':'260px')}"  v-for="(ite,ind) in item.swipter" :key="(ind)">
						        <img class="wh100" :src="ite.imgUrl"  :style="{height:item.style.column==3?'110px':'260px'}" alt="" />
						      </el-carousel-item>
						</el-carousel> -->
								<div class="goods-item" v-for="(dataItm, dataIdx) in tabActive(item)['source'] == 'choice'
			        ? tabActive(item)['goods']
			        : tabActive(item)['defaultGoods']" :key="`${index}_${dataIdx}`" :class="[`display-${item.style.cardType}`]"
									:style="{
			        marginBottom: `${item.style.itemMargin}px`,
			        borderRadius: `${item.style.borderRadius}px`,
			      }">
									<!-- 单列商品 -->
									<template v-if="item.style.column == 1">
										<div class="flex">
											<!-- 商品图片 -->

											<div class="goods-item-left">
												<img v-if='item.style.hotTag==1' class="image_tag"
													:src="item.style.hotImg" />
												<img class="image" :src="dataItm.goods_image" />
											</div>
											<div class="goods-item-right">
												<div class="goods-info">
													<div v-if="$util.inArray('goodsName', item.style.show)"
														class="goods-name" :class="[
			                  item.style.goodsNameRows == 'two'
			                    ? 'twoline-hide'
			                    : 'oneline-hide',
			                  `row-${item.style.goodsNameRows}`,
			                ]" :style="{fontWeight:item.style.goodsWeight,fontSize:(item.style.goodsSize?item.style.goodsSize:14)+'px'}">
														{{ dataItm.goods_name }}
													</div>
													<!-- <div
			                v-if="$util.inArray('sellingPoint', item.style.show)"
			                class="goods-selling"
			              >
			                <span
			                  class="selling oneline-hide"
			                  :style="{ color: item.style.sellingColor }"
			                  >{{ dataItm.selling_point }}</span
			                >
			              </div> -->
													<div v-if="$util.inArray('goodsTag', item.style.show)"
														class="goods-tag">
														<span class="goods-tag-style1 goods-tag-item"
															:style="{ 'color': item.style.sellingColor }">3.5折</span>
														<!-- <span class="goods-tag-style2 goods-tag-item" :style="{ 'color': item.style.sellingColor,'border': '1px solid '+ item.style.sellingColor }">品牌</span> -->
														<!-- <view class="goods-tag-style2 goods-tag-item">{{ite.name || ''}}</view> -->
														<!-- <span class="goods-tag-style2 goods-tag-item" :style="{ 'color': item.style.sellingColor,'border': '1px solid '+ item.style.sellingColor }">同城配送</span> -->
														<!-- <span class="goods-tag-style2 goods-tag-item" :style="{ 'color': item.style.sellingColor,'border': '1px solid '+ item.style.sellingColor }">活动</span> -->
													</div>
													<div style="display:flex">
														<div v-if=" $util.inArray('goodsGrade', item.style.show)"
															:style="{background:item.style.sellingColor+'1A'}"
															class="zu_a   " style="margin-right: 10px;">
															<div class="zu_a1"
																:style="{ '--after-bg-color':item.style.sellingColor,'background': item.style.sellingColor }">
																尊享价</div>
															<div class="flex_c ml10">
																<div class="zu_a_price">
																	<div class="zu_a_type"
																		:style="{ 'color': item.style.sellingColor }">￥
																	</div>
																	<div class="zu_a_num"
																		:style="{ 'color': item.style.sellingColor }">
																		{{dataItm.goods_price_min}}</div>
																</div>
															</div>
														</div>
														<div v-if="$util.inArray('goodsSales', item.style.show)"
															class="goods-sales oneline-hide">
															<span class="sales">已售{{ dataItm.goods_sales }}</span>
														</div>
													</div>
													<div class="footer">
														<div v-if="$util.inArray('goodsPrice', item.style.show)"
															class="goods-price oneline-hide"
															:style="{ color: item.style.priceColor }">
															<span class="unit">￥</span>
															<span class="value">{{
			                    dataItm.goods_price_min
			                  }}</span>
															<!-- <span class="unit2">到手价</span> -->
															<span v-if="$util.inArray('linePrice', item.style.show)"
																class="line-price">
																<span class="unit">￥</span>
																<span class="value">{{
			                      dataItm.line_price_min
			                    }}</span>
															</span>
														</div>
														<div v-show="
			                    $util.inArray('cartBtn', item.style.show) &&
			                    item.style.column < 3
			                  " class="action">
															<div class="btn-cart"
																:style="{ color: item.style.btnCartColor }"
																style="width: auto;">
																<span
																	v-if="item.style.btnCartStyle==1||item.style.btnCartStyle==3"
																	class="cart-icon iconfont"
																	:class="[`icon-jiagou${item.style.btnCartStyle}`]"></span>
																<span v-if="item.style.btnCartStyle==2"
																	:style="{background:item.style.btnCartColor}"
																	style="width: 18px;height: 18px;line-height: 18px; border-radius: 50%;text-align: center;color: #fff;display: inline-block;">
																	<i class="cart-icon iconfont icon-jiagou3"
																		style="font-size: 12px;"></i>
																</span>
																<span class="cart-an" v-if="item.style.btnCartStyle==4"
																	:style="{background:item.style.btnCartColor}"
																	style="">
																	购买
																</span>
																<!-- <a-icon
			                      class="cart-icon"
			                      :component="PageIcon[`jiagou${item.style.btnCartStyle}`]"
			                    /> -->
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</template>
									<!-- 两列/三列 -->
									<template v-else>
										<div class="goods-image">
											<img v-if='item.style.hotTag==1' class="image_tag"
												:src="item.style.hotImg" />
											<img class="image" :src="dataItm.goods_image" />
										</div>
										<div class="goods-info">
											<div v-if="$util.inArray('goodsName', item.style.show)" class="goods-name"
												:class="[
			              item.style.goodsNameRows == 'two'
			                ? 'twoline-hide'
			                : 'oneline-hide',
			              `row-${item.style.goodsNameRows}`,
			            ]" :style="{fontWeight:item.style.goodsWeight,fontSize:(item.style.goodsSize?item.style.goodsSize:14)+'px'}">
												{{ dataItm.goods_name }}
											</div>
											<div v-if="$util.inArray('goodsTag', item.style.show)" class="goods-tag">
												<span class="goods-tag-style1 goods-tag-item"
													:style="{ 'color': item.style.sellingColor }">{{((dataItm.goods_price_min/dataItm.line_price_min).toFixed(1))*10}}折</span>
												<!-- <span class="goods-tag-style2 goods-tag-item" :style="{ 'color': item.style.sellingColor,'border': '1px solid '+ item.style.sellingColor }">同城配送</span> -->
												<!-- <span class="goods-tag-style2 goods-tag-item" :style="{ 'color': item.style.sellingColor,'border': '1px solid '+ item.style.sellingColor }">品牌</span> -->
												<!-- <view class="goods-tag-style2 goods-tag-item">{{ite.name || ''}}</view> -->
												<!-- <span class="goods-tag-style2 goods-tag-item" :style="{ 'color': item.style.sellingColor,'border': '1px solid '+ item.style.sellingColor }">活动</span> -->
											</div>
											<div style="display:flex">
												<!-- v-if="dataItm.is_user_grade" -->
												<div v-if="$util.inArray('goodsGrade', item.style.show)"
													:style="{background:item.style.sellingColor+'1A'}" class="zu_a   "
													style="margin-right: 10px;">
													<div class="zu_a1"
														:style="{ '--after-bg-color':item.style.sellingColor,'background': item.style.sellingColor }">
														尊享价</div>
													<div class="flex_c ml10">
														<div class="zu_a_price">
															<div class="zu_a_type"
																:style="{ 'color': item.style.sellingColor }">￥</div>
															<div class="zu_a_num"
																:style="{ 'color': item.style.sellingColor }">
																{{dataItm.goods_price_min}}</div>
														</div>
													</div>
												</div>
												<div v-if="$util.inArray('goodsSales', item.style.show)"
													class="goods-sales oneline-hide">
													<span class="sales">已售{{ dataItm.goods_sales }}</span>
												</div>
											</div>
											<!-- <div
			            v-if="$util.inArray('goodsSales', item.style.show)"
			            class="goods-sales oneline-hide"
			          >
			            <span class="sales">已售{{ dataItm.goods_sales }}</span>
			          </div> -->
											<div class="footer">
												<div v-if="$util.inArray('goodsPrice', item.style.show)"
													class="goods-price oneline-hide"
													:style="{ color: item.style.priceColor }">
													<span class="unit">￥</span>
													<span class="value">{{ dataItm.goods_price_min }}</span>
													<!-- <span class="unit2">到手价</span> -->
													<span v-if="$util.inArray('linePrice', item.style.show)"
														class="line-price">
														<span class="unit">￥</span>
														<span class="value">{{
			                  dataItm.line_price_min
			                }}</span>
													</span>
												</div>
												<div v-show="
			                $util.inArray('cartBtn', item.style.show) &&
			                item.style.column < 3
			              " class="action">
													<div class="btn-cart" :style="{ color: item.style.btnCartColor }"
														style="width: auto;">
														<!-- <span class="cart-icon iconfont" :class="[`icon-jiagou${item.style.btnCartStyle}`]"></span> -->
														<span
															v-if="item.style.btnCartStyle==1||item.style.btnCartStyle==3"
															class="cart-icon iconfont"
															:class="[`icon-jiagou${item.style.btnCartStyle}`]"></span>
														<span v-if="item.style.btnCartStyle==2"
															:style="{background:item.style.btnCartColor}"
															style="width: 18px;height: 18px;line-height: 18px; border-radius: 50%;text-align: center;color: #fff;display: inline-block;">
															<i class="cart-icon iconfont icon-jiagou3"
																style="font-size: 12px;"></i>
														</span>
														<span class="cart-an" v-if="item.style.btnCartStyle==4"
															:style="{background:item.style.btnCartColor}" style="">
															购买
														</span>
														<!-- <a-icon
			                  class="cart-icon"
			                  :component="PageIcon[`jiagou${item.style.btnCartStyle}`]"
			                /> -->
													</div>
												</div>
											</div>
											<div v-if="$util.inArray('goodsTop', item.style.show)" class="good-top">
												店铺人气榜商品前TOP10</div>
										</div>
									</template>
								</div>
							</div>
						</div>
					</div>
					<!-- 辅助空白 -->
					<div v-else-if="item.type == 'blank'" class="diy-blank" :style="{
              height: `${item.style.height}px`,
              background: item.style.background,
            }"></div>

					<!-- 辅助线 -->
					<div v-else-if="item.type == 'guide'" class="diy-guide" :style="{
              padding: `${item.style.paddingTop}px ${item.style.paddingLeft}px`,
              background: item.style.background,
            }">
						<p class="line" :style="{
                borderTopWidth: item.style.lineHeight + 'px',
                borderTopColor: item.style.lineColor,
                borderTopStyle: item.style.lineStyle,
              }"></p>
					</div>

					<!-- 在线客服 -->
					<div v-else-if="item.type == 'service'" class="diy-service"
						:style="{ opacity: item.style.opacity / 100 }">
						<div class="service-icon">
							<img class="image" :src="item.params.image" alt />
						</div>
					</div>

					<!-- 富文本 -->
					<div v-else-if="item.type == 'richText'" class="diy-richText" :style="{
              background: item.style.background,
               padding: item.style.paddingTop +'px '+item.style.paddingRight +'px '+item.style.paddingBottom +'px '+item.style.paddingLeft +'px',
            }" v-html="item.params.content"></div>

					<!-- 关注公众号 -->
					<div v-else-if="item.type == 'officialAccount'" class="diy-officialAccount">
						<div class="item-top">
							<span>关联的公众号</span>
						</div>
						<div class="item-content clearfix">
							<div class="item-cont-avatar fl-l">
								<img src="~@/assets/img/circular.png" alt />
							</div>
							<div class="item-cont-public fl-l">
								<div class="public-name">
									<span>公众号名称</span>
								</div>
								<div class="public-describe">
									<span>公众号简介公众号简介公众号简介</span>
								</div>
							</div>
							<div class="item-cont-active fl-l">
								<div class="active-btn">
									<span>关注</span>
								</div>
							</div>
						</div>
					</div>

					<!-- 优惠券 -->
					<div v-else-if="item.type == 'coupon'" style="overflow:hidden" :style="{
					  background: item.style.zubackground,
					}">
											<div class="diy-coupon" :style="{
									  margin: `${item.style.paddingTop}px ${item.style.paddingRight}px ${item.style.paddingBottom}px ${item.style.paddingLeft}px`,
									  background: item.style.background,
									  borderRadius:`${item.style.borderRadius}px ${item.style.borderRadius}px ${item.style.borderRadius1}px ${item.style.borderRadius1}px`
									}">
												<div class="coupon_head">
													<div class="coupon_head_title" :style="{color:item.style.titleColor}">
														{{item.params.title}}</div>
													<div class="coupon_head_more" :style="{color:item.style.titleColor}">查看更多</div>
												</div>
												<div class="coupon-wrapper">
													<div class="coupon-item" v-for="(coupon, idx) in item.params.source == 'choice'
										  ? item.data.length
											? item.data
											: item.defaultData
										  : item.defaultData" :key="idx" :style="{ background: item.style.couponBgColor }">
														<div class="coupon-item-al" :style="{ background: item.style.background }">
															
														</div>
														<div class="coupon-item-ar" :style="{ background: item.style.background }">
															
														</div>
														<div class="left-content" >
															<div class="content-top">
																<template v-if="coupon.coupon_type == 10">
																	<span class="unit" :style="{
											color: item.style.receiveTextColor }">￥</span>
																	<span class="price" :style="{
											color: item.style.receiveTextColor }">{{ coupon.reduce_price }}</span>
																</template>
																<template v-if="coupon.coupon_type == 20">
																	<span class="price" :style="{
											color: item.style.receiveTextColor }">{{ coupon.discount }}折</span>
																</template>
															</div>
															<div class="content-bottom">
																<span :style="{
											color: item.style.couponTextColor }">满{{ coupon.min_price }}元可用</span>
															</div>
														</div>
														<!-- <div class="right-zhan" :style="{
											background: item.style.receiveBgColor
										  }"></div> -->
														<div class="right-receive" :style="{borderColor:item.style.receiveBgColor}">
															<span :style="{
											color: item.style.receiveTextColor,
										  }">立即领取</span>
														</div>
													</div>
												</div>
											</div>
										</div>

					<!-- 头条快报 -->
					<div v-else-if="item.type == 'special'" class="diy-special" :style="{
              padding: `${item.style.paddingTop}px 0`,
              background: item.style.background,
            }">
						<div class="special-left">
							<img class="image" :src="item.params.image" alt />
						</div>
						<div class="special-content" :class="[`display_${item.params.display}`]">
							<ul class="special-content-list">
								<li class="content-item oneline-hide" v-for="(dataItm, idx) in item.params.source == 'choice'
                    ? item.data
                    : item.defaultData" :key="idx">
									<span :style="{ color: item.style.textColor }">{{
                    dataItm.title
                  }}</span>
								</li>
							</ul>
						</div>
						<div class="special-more">
							<!--<a-icon :component="Icon.arrowRight" />-->
						</div>
					</div>

					<!-- 网站备案号 -->
					<div v-else-if="item.type == 'ICPLicense'" class="diy-ICPLicense" :style="{
              padding: `${item.style.paddingTop}px ${item.style.paddingLeft}px`,
              background: item.style.background,
            }">
						<p class="line" :style="{ textAlign: item.style.textAlign }">
							<a :style="{
                  fontSize: item.style.fontSize + 'px',
                  color: item.style.textColor,
                }" :href="item.params.link" target="_blank">{{ item.params.text }}</a>
						</p>
					</div>

					<!-- 标题文本 -->
					<div v-else-if="item.type == 'title'" class="diy-title" :style="{
			  padding: `${item.style.paddingY}px ${item.style.paddingX1}px  ${item.style.paddingY1}px  ${item.style.paddingX}px`,
              background: item.style.background,
            }">
						<div class="title-content">
							<!-- 标题文字 -->
							<div class="title">
								<span :style="{
                    color: item.style.titleTextColor,
                    fontSize: `${item.params.titleFontSize}px`,
                    fontWeight: item.params.titleFontWeight,
                  }">{{ item.params.title }}</span>
							</div>
							<!-- 查看更多 -->
							<div v-if="item.params.more.enable" class="more-content"
								:style="{ color: item.style.moreTextColor }">
								<span class="more-text">{{ item.params.more.text }}</span>
								<span v-if="item.params.more.enableIcon" class="more-icon">
									<!-- <a-icon :component="Icon.arrowRight" /> -->
									<i class="el-icon-arrow-right"></i>
								</span>
							</div>
						</div>
						<!-- 描述文字 -->
						<div class="desc-content">
							<span :style="{
                  color: item.style.descTextColor,
                  fontSize: `${item.params.descFontSize}px`,
                  fontWeight: item.params.descFontWeight,
                }">{{ item.params.desc }}</span>
						</div>
					</div>

					<!-- 操作工具栏 -->
					<div class="action-tools">
						<div class="tools-content">
							<div class="tools-item" v-for="(itm, idx) in actionTools(item, index)" :key="idx">
								<el-tooltip effect="dark" :content="itm.title" placement="right">
									<div class="item-btn" :class="{ disabled: itm.disabled }"
										@click.stop="handleActionToolItem(itm, index)">
										<!-- <i :class="itm.type"></i> -->
										<img :style="{ opacity: itm.disabled ? 0.2 : 1 }"
											style="width: 26px; height: 26px" :src="itm.typeImg" alt="" srcset="" />
										<!-- <a-icon class="tools-icon" :type="itm.type" /> -->
									</div>
								</el-tooltip>
							</div>
						</div>
					</div>
				</div>
			</draggable>
		</div>
	</div>
</template>

<script>
	// import PropTypes from 'ant-design-vue/es/_util/vue-types'
	import draggable from "vuedraggable";
	// import { inArray } from '@/util/util'
	import * as PageIcon from "@/assets/icons/page";
	// import * as Icon from '@/core/icons'
	import {
		UTag
	} from "./modules";
	import html2canvas from "html2canvas";
	import {
		data
	} from "autoprefixer";
	import {
		over
	} from "lodash";
	/* ES6 */
	import {
		LazyImg,
		Waterfall
	} from 'vue-waterfall-plugin'
	import 'vue-waterfall-plugin/dist/style.css'

	lifelistBox
	import lifelistBox from "./modules/lifelist"
	// 禁止拖拽的组件
	const undragList = ["service"];

	export default {
		props: {
			// 页面数据
			data: {},
			// 当前选中的元素索引
			selectedIndex: 0,
		},
		components: {
			draggable,
			UTag,
			lifelistBox
		},
		data() {
			return {
				// 禁止拖拽的组件
				undragList,
			};
		},
		computed: {},
		mounted() {
			console.log(11, this.data);

		},
		beforeCreate() {
			// this.Icon = Icon
			this.PageIcon = PageIcon;
		},
		methods: {
			getBackground(page){
				let _this = this
				if(page.params.zubackground){
					if(page.params.zubackground==1){
						return page?.style?.backgroundPageTop+' 0%, '+page?.style?.backgroundPage+' '+page?.style?.backgroundPageHeight+'px'+', '+page?.style?.backgroundPage+' 100vh'
					}else{
						return page?.style?.backgroundPage+' , '+page?.style?.backgroundPage
					}
				}else{
					return page?.style?.backgroundPage+' , '+page?.style?.backgroundPage
				}
			},
			getHeadBg(e) {
				if (e.params.model_type == 1) {
					if (e.params.bgstyle == 2) {
						return {
							backgroundImage: 'url(' + e.style.titleBackgroundImg + ')',
							backgroundColor: e.style.backgroundPage
						}
					} else {
						return {
							backgroundColor: e.style.titleBackgroundColor
						}
					}
					// if(e.params.bgstyle==2){
					// 	  			  return {backgroundColor:e.style.titleBackgroundColor}
					// }else{
					// 	  			  return {backgroundImage:'url('+e.style.titleBackgroundImg+')'}
					// }
				} else {
					return {
						backgroundColor: e.style.titleBackgroundColor
					}
				}

			},
			getDelivery(e) {
				let d = []
				e.map(res => {
					switch (res) {
						case 10:
							d.unshift("快递配送")
							break;
						case 20:
							d.unshift("到店自提")
							break;
						case 30:
							// d.push("同城")
							break;
						case 40:
							d.unshift("同城配送")
							break;
						default:
							break;
					}
				})
				return d
			},
			getService(e) {
				if (e.length > 0) {
					return [e[0]]
				} else {
					return []
				}
			},
			// 限时秒杀样式
			seckillStyle(item) {
				let sty = {
					marginTop: item.style.paddingTop + 'px',
					marginBottom: item.style.paddingBottom + 'px',
					marginLeft: item.style.paddingLeft + 'px',
					marginRight: item.style.paddingRight + 'px',
					borderRadius: item.style.borderRadius + 'px'
				}
				if (item.style.bgType == "color") {
					sty.background = item.style.background
				} else {
					sty.background = "url('" + item.style.backgroundimg + "') no-repeat center"
					sty.backgroundSize = '100% 100%'
				}
				return sty
			},

			// 使用cavas截图
			saveImag() {
				let dom = document.getElementById("phone-main");
				// 截图前暂停视频并隐藏视频元素，强制显示 poster
				if (document.querySelectorAll("video")) {
					const videos = document.querySelectorAll("video");
					// video.pause();
					// console.log("我在打印视频的宽高", video.offsetWidth);
					videos.forEach((video) => {
						// 创建一个 poster 图片元素
						const poster = document.createElement("img");

						// 获取视频的 poster 属性并设置为图片的源
						poster.src = video.getAttribute("poster");

						// 设置 poster 图片的宽高与视频元素相同
						poster.style.width = video.offsetWidth + "px";
						poster.style.height = video.offsetHeight + "px";
						// 去除图片的下边距
						poster.style.marginBottom = "0";
						poster.style.marginTop = "-18px";
						poster.style.paddingBottom = "0";

						// 设置图片为块级元素并去除默认的下边距
						poster.style.display = "block";
						poster.style.verticalAlign = "top"; // 确保图片没有底边距
						// 给 poster 图片添加一个自定义类名
						poster.classList.add("my-poster-class");
						// 将 poster 图片添加到视频元素的父节点中
						video.parentNode.appendChild(poster);

						// 隐藏视频元素
						video.style.display = "none";

						// 在一定延时后移除 poster 图片
					});
				}

				//将视图窗口改为图片大小
				const width = dom.offsetWidth;
				const height = (width * 300) / 170;
				dom.style.height = height + "px";
				let borderArr = document.querySelectorAll(".optional");
				borderArr.forEach((idom) => {
					idom.style.setProperty("--zIndex", "-1");
				});
				html2canvas(dom, {
					useCORS: true,
				}).then((img) => {
					let file = this.base64ToFile(img.toDataURL(), "image.png");
					dom.style.height = "auto";
					borderArr.forEach((idom) => {
						idom.style.setProperty("--zIndex", "2");
					});
					if (document.querySelectorAll("video")) {
						const videos = document.querySelectorAll("video");
						videos.forEach((video) => {
							// 恢复视频的显示
							video.style.display = "";
							// 恢复视频的其他样式（如果有其他样式变更，可以在这里加上）
							// 移除视频的 poster 图片
							const videoPosters =
								video.parentNode.querySelectorAll(".my-poster-class");
							videoPosters.forEach((poster) => poster.remove());
						});
					}
					this.$emit("uploadImgMallDecoration", file);
				});
			},
			//base64 转为file
			base64ToFile(base64String, filename) {
				// 先分离出 MIME 类型和 Base64 数据
				const arr = base64String.split(",");
				const mime = arr[0].match(/:(.*?);/)[1]; // 获取 MIME 类型
				const bstr = atob(arr[1]); // 解码 Base64
				let n = bstr.length;
				const u8arr = new Uint8Array(n);

				while (n--) {
					u8arr[n] = bstr.charCodeAt(n);
				}

				// 创建 File 对象
				return new File([u8arr], filename, {
					type: mime
				});
			},
			/**
			 * 操作工具栏
			 * @param item
			 * @param index
			 */
			actionTools(item, index) {
				const {
					data: {
						items
					},
				} = this;
				const isUndrag = this.$util.inArray(item.type, undragList);
				return [{
						title: "组件上移",
						type: "el-icon-top",
						typeImg: require("@/assets/page/caozuo/top.png"),
						disabled: isUndrag ||
							index == 0 ||
							this.$util.inArray(items[index - 1].type, undragList),
					},
					{
						title: "组件下移",
						typeImg: require("@/assets/page/caozuo/down.png"),
						type: "el-icon-bottom",
						disabled: isUndrag ||
							items.length <= index + 1 || items.type != 'stores' ||
							this.$util.inArray(items[index + 1].type, undragList),
					},
					{
						title: "复制组件",
						typeImg: require("@/assets/page/caozuo/copy.png"),
						type: "el-icon-document-copy",
						disabled: false,
					},
					{
						title: "删除组件",
						typeImg: require("@/assets/page/caozuo/del.png"),
						type: "el-icon-close",
						disabled: false,
					},
				];
			},

			/**
			 * 拖动diy元素更新当前索引
			 * @param e
			 */
			handelDragItem(e) {
				this.$emit("onEditer", e.newIndex);
			},
			tabActive(item) {
				let d = ''
				item.params.tab.map(red => {
					if (item.params.tabVals == red.index) {
						d = red
					}
				})
				return d
			},
			/**
			 * 点击当前选中的Diy元素
			 * @param index
			 */
			handelClickItem(index) {
				console.log("index",index)
				this.$emit("onEditer", index);
			},

			// 操作工具栏点击事件
			handleActionToolItem(acItem, index) {
				!acItem.disabled && this.$emit("onActionItem", acItem.type, index);
			},

			// 渲染组件外层容器的样式
			renderItemStyle(item) {
				if (item.type === "service") {
					return {
						position: "absolute",
						right: item.style.right + "px",
						bottom: item.style.bottom + "px",
						zIndex: 999,
					};
				}
				return {};
			},
		},
	};
</script>
<style lang="less" scoped>
	@import "./style.less";
	@import "./iconfont_uni.css";

	.column1 {}

	// 两列布局 - 使用 Flexbox 实现 Z 字形排序（横向排序）
	.column2 {
		display: block !important;

		.display-list {
			display: flex !important;
			flex-wrap: wrap;
			justify-content: space-between;
		}

		.goods-item {
			width: calc(50% - 5px); // 两列，每个占 50% 减去间距
			margin-right: 0 !important;
			margin-bottom: 10px;
			box-sizing: border-box;
		}
	}

	// 三列布局 - 使用 Flexbox 实现 Z 字形排序（横向排序）
	.column3 {
		display: block !important;

		.display-list {
			display: flex !important;
			flex-wrap: wrap;
			justify-content: space-between;
		}

		.goods-item {
			width: calc(33.33% - 7px); // 三列，每个占 33.33% 减去间距
			margin-right: 0 !important;
			margin-bottom: 10px;
			box-sizing: border-box;
		}
	}

	.wh100 {
		width: 100%;
		overflow: hidden;
	}

	.zu_a {
		height: 20px;
		line-height: 20px;
		border-radius: 2px;
		display: flex;
		overflow: hidden;

		&_price {
			display: flex;
			align-items: flex-end;
			padding-right: 4px;
		}

		&_type {
			font-size: 12px;
			line-height: 12px;
			// color: $main-bg;
		}

		&_num {
			font-size: 14px;
			font-weight: bold;
			line-height: 12px;
			// color: $main-bg;
		}
	}

	.zu_a1 {
		// background: $main-bg;
		height: 20px;
		line-height: 20px;
		color: #fff;
		font-size: 12px;
		padding: 0 3px;
		position: relative;
		z-index: 1;

		&::after {
			position: absolute;
			content: '';
			height: 30px;
			width: 5px;
			background-color: var(--after-bg-color, red);
			z-index: 0;
			transform: rotate(-9deg);
			right: -2px;
			bottom: -2px;
		}
	}

	.goods-tag {
		margin-bottom: 5px;
		white-space: nowrap;

		&-item {
			font-size: 12px;
			padding: 0 6px;
			height: 20px;
			border-radius: 3px;
			line-height: 18px;
			display: inline-flex;
			text-align: center;
			justify-content: center;
			margin-right: 5px;
		}

		&-style1 {
			// color: $main-bg;
			border: 1px solid #fef5e6;
			font-weight: bold;
			background-color: #fef5e6;
		}

		// &-style2{
		//  color: $main-bg;
		//  border: 1px solid $main-bg;
		// }
	}
</style>